import { BACKEND_URL } from "@/lib/api";

// Resolve image URLs that come from the admin image upload (served at /api/files/<path>)
// so they work on the public site without re-coding.
export function resolveImg(url) {
  if (!url) return "";
  if (url.startsWith("http") || url.startsWith("data:")) return url;
  if (url.startsWith("/api/")) return `${BACKEND_URL}${url}`;
  return url;
}
